// guest authenticate actions
export const DEMO_ACTION_TYPE = "DEMO_ACTION_TYPE";
export const AUTH_INIT_GUEST_LOGIN = "AUTH_INIT_GUEST_LOGIN";
export const ACTIVATE_GUEST = "ACTIVATE_GUEST";
export const LANGUAGE_CHANGE = "LANGUAGE_CHANGE";
export const ISLOGIN = "LOGIN";
